import { coolify } from '@t3-oss/env-core/presets-zod';
import { createEnv } from '@t3-oss/env-nextjs';
import { z } from 'zod/v4';

export const env = createEnv({
    extends: [coolify()],
    shared: {
        /* Docker */
        DOCKER: z.stringbool().optional(),

        /* Node */
        NODE_ENV: z.enum(['development', 'production', 'test']).default('development'),
    },
    server: {
        /* Revalidation */
        REVALIDATE_TOKEN: z.string().min(10)
    },
    client: {
        /* API */
        NEXT_PUBLIC_SERVER_URL: z.url(),

        /* HTTP logging */
        NEXT_PUBLIC_HTTP_LOGGING_ENABLED: z
            .enum(['true', 'false', ''])
            .optional()
            .transform(s => s === 'true')
            .pipe(z.boolean()),

        /* Telegram */
        NEXT_PUBLIC_TELEGRAM_BOT: z.string().endsWith('bot'),
        NEXT_PUBLIC_TELEGRAM_SUPPORT: z.string(),

        /* Tinkoff */
        NEXT_PUBLIC_TINKOFF_TERMINAL_KEY: z.string(),

        /* Payments problem feature flag */
        NEXT_PUBLIC_PAYMENTS_PROBLEM: z
            .enum(['true', 'false', ''])
            .optional()
            .transform(s => s === 'true')
            .pipe(z.boolean()),

        /* Yandex */
        NEXT_PUBLIC_YANDEX_MAPS_API_KEY: z.string(),
        NEXT_PUBLIC_YANDEX_METRIKA_ID: z.coerce
            .number()
            .optional()
            .catch((ctx): number | undefined => {
                const v = ctx.value;
                if (typeof v === 'number' && !Number.isNaN(v)) {
                    return v;
                }
                return undefined;
            })
            .pipe(z.number()),
        NEXT_PUBLIC_YANDEX_WEBMASTER_VERIFICATION: z.string(),
    },
    experimental__runtimeEnv: {
        /* Docker */
        DOCKER: process.env.DOCKER,

        /* Node */
        NODE_ENV: process.env.NODE_ENV,

        /* API */
        NEXT_PUBLIC_SERVER_URL: process.env.NEXT_PUBLIC_SERVER_URL,

        /* Environment */
        NEXT_PUBLIC_HTTP_LOGGING_ENABLED: process.env.NEXT_PUBLIC_HTTP_LOGGING_ENABLED,

        /* Telegram */
        NEXT_PUBLIC_TELEGRAM_BOT: process.env.NEXT_PUBLIC_TELEGRAM_BOT,
        NEXT_PUBLIC_TELEGRAM_SUPPORT: process.env.NEXT_PUBLIC_TELEGRAM_SUPPORT,

        /* Tinkoff */
        NEXT_PUBLIC_TINKOFF_TERMINAL_KEY: process.env.NEXT_PUBLIC_TINKOFF_TERMINAL_KEY,

        /* Payments problem flag */
        NEXT_PUBLIC_PAYMENTS_PROBLEM: process.env.NEXT_PUBLIC_PAYMENTS_PROBLEM,

        /* Yandex */
        NEXT_PUBLIC_YANDEX_MAPS_API_KEY: process.env.NEXT_PUBLIC_YANDEX_MAPS_API_KEY,
        NEXT_PUBLIC_YANDEX_METRIKA_ID: process.env.NEXT_PUBLIC_YANDEX_METRIKA_ID,
        NEXT_PUBLIC_YANDEX_WEBMASTER_VERIFICATION: process.env.NEXT_PUBLIC_YANDEX_WEBMASTER_VERIFICATION,
    },
    skipValidation: !!process.env.CI || process.env.npm_lifecycle_event === 'lint',
    emptyStringAsUndefined: true,
});
